import { ReactNode, useEffect, useRef, useState } from "react";
import { OptionMenuContainer } from "../ui/OptionMenu";
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';

interface Props {
    options: ReactNode[];
}

export function OptionMenu({ options }: Props) {
    const [openMenu, setOpenMenu] = useState(false);

    const buttonRef = useRef<HTMLButtonElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if(modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setOpenMenu(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    return (

        <div className="relative">
            <button
                ref={buttonRef}
                className={`rounded-[4px] hover:bg-[#e2e8f0] ${openMenu ? "bg-[#e2e8f0]" : "bg-none"}`}
                onClick={() => setOpenMenu(!openMenu)}>
                <MoreVertRoundedIcon />
            </button>

            {openMenu && (
            <div
                ref={modalRef}
                className="absolute"
                style={{ insetInlineEnd: 0 }}>
                <OptionMenuContainer>
                    {options.map((node, index) => (
                    <div 
                        onClick={() => setOpenMenu(false)}
                        key={index}>
                        {node}
                    </div>
                    ))}
                </OptionMenuContainer>
            </div>
            )}

        </div>
    );
}
